<div class="p-6 md:px-12 lg:py-0 container mx-auto relative">
    <div class="grid grid-cols-12 gap-4" data-aos="fade-up"  data-aos-delay="300">
        <div class="col-span-12 md:col-span-6" >
            <div class="relative">
                <h2 class="text__grey--gradient text-4xl sm:text-5xl md:text-7xl lg:text-7xl xl:text-9xl mi--font-regular title-l35">Explore</h2>
                <p class="text-white text-xl sm:text-2xl lg:text-3xl xl:text-4xl mi--font-regular absolute -bottom-2 xl:bottom-0 xl:left-[3.75rem]">The ecosystem</p>
            </div>
        </div>
        <div class="col-span-12 md:col-span-6">
            <div class="flex items-center justify-end gap-4 lg:mt-12">
                <p class="text-[#D9D9D9] text-sm md:text-base lg:text-lg ep--font-light"> Each module in BX Finance is tried, tested, and proven in the market. Create no code web3 projects with pre-audited smart contracts and an easy-to-use interface</p>
            </div>
        </div>
    </div>
    <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink bottom-0 right-24 w-10 h-10" alt="">
</div>
